// Données factices pour les tests et le développement

export interface FakeAlerte {
  id: string;
  description?: string;
  libelleAlerte?: string;
  typeTravaux?: { libelleTypeTravaux: string };
  libelleTypeTravaux?: string;
  priorite?: { libellePriorite: string; id: string };
  libellePriorite?: string;
  commune?: { libelleCommune: string };
  libelleCommune?: string;
  dateCreation?: string;
  statutAlerte?: { libelleStatutAlerte: string };
  libelleStatutAlerte?: string;
}

export const fakeAlertes: FakeAlerte[] = [
  {
    id: "1",
    description: "Nid de poule important sur la route principale",
    libelleAlerte: "Nid de poule - Route principale",
    typeTravaux: { libelleTypeTravaux: "Réparation chaussée" },
    priorite: { libellePriorite: "Haute", id: "1" },
    commune: { libelleCommune: "Dakar" },
    dateCreation: "2026-02-10T10:30:00",
    statutAlerte: { libelleStatutAlerte: "En cours" },
  },
  {
    id: "2",
    description: "Fissure importante sur le pont",
    libelleAlerte: "Fissure pont - Zone industrielle",
    typeTravaux: { libelleTypeTravaux: "Réparation structure" },
    priorite: { libellePriorite: "Urgente", id: "1" },
    commune: { libelleCommune: "Thiès" },
    dateCreation: "2026-02-08T14:20:00",
    statutAlerte: { libelleStatutAlerte: "Non démarrée" },
  },
  {
    id: "3",
    description: "Signalisation manquante à l'intersection",
    libelleAlerte: "Signalisation manquante",
    typeTravaux: { libelleTypeTravaux: "Installation signalisation" },
    priorite: { libellePriorite: "Moyenne", id: "2" },
    commune: { libelleCommune: "Saint-Louis" },
    dateCreation: "2026-02-12T09:15:00",
    statutAlerte: { libelleStatutAlerte: "En pause" },
  },
  {
    id: "4",
    description: "Éclairage public défaillant",
    libelleAlerte: "Éclairage défaillant - Avenue principale",
    typeTravaux: { libelleTypeTravaux: "Maintenance éclairage" },
    priorite: { libellePriorite: "Basse", id: "3" },
    commune: { libelleCommune: "Kaolack" },
    dateCreation: "2026-02-11T16:45:00",
    statutAlerte: { libelleStatutAlerte: "Terminée" },
  },
  {
    id: "5",
    description: "Barrière de sécurité endommagée",
    libelleAlerte: "Barrière endommagée - Route nationale",
    typeTravaux: { libelleTypeTravaux: "Réparation sécurité" },
    priorite: { libellePriorite: "Haute", id: "1" },
    commune: { libelleCommune: "Dakar" },
    dateCreation: "2026-02-09T11:00:00",
    statutAlerte: { libelleStatutAlerte: "En cours" },
  },
  {
    id: "6",
    description: "Marquage au sol effacé",
    libelleAlerte: "Marquage effacé - Carrefour",
    typeTravaux: { libelleTypeTravaux: "Réfection marquage" },
    priorite: { libellePriorite: "Moyenne", id: "2" },
    commune: { libelleCommune: "Ziguinchor" },
    dateCreation: "2026-02-13T08:30:00",
    statutAlerte: { libelleStatutAlerte: "Non affectée" },
  },
  {
    id: "7",
    description: "Dégradation importante de la chaussée",
    libelleAlerte: "Dégradation chaussée - Zone résidentielle",
    typeTravaux: { libelleTypeTravaux: "Réparation chaussée" },
    priorite: { libellePriorite: "Urgente", id: "1" },
    commune: { libelleCommune: "Thiès" },
    dateCreation: "2026-02-07T13:20:00",
    statutAlerte: { libelleStatutAlerte: "En cours" },
  },
  {
    id: "8",
    description: "Panneau de signalisation tombé",
    libelleAlerte: "Panneau tombé - Route secondaire",
    typeTravaux: { libelleTypeTravaux: "Installation signalisation" },
    priorite: { libellePriorite: "Haute", id: "1" },
    commune: { libelleCommune: "Louga" },
    dateCreation: "2026-02-14T10:00:00",
    statutAlerte: { libelleStatutAlerte: "Non démarrée" },
  },
  {
    id: "9",
    description: "Glissière de sécurité endommagée",
    libelleAlerte: "Glissière endommagée",
    typeTravaux: { libelleTypeTravaux: "Réparation sécurité" },
    priorite: { libellePriorite: "Moyenne", id: "2" },
    commune: { libelleCommune: "Dakar" },
    dateCreation: "2026-02-06T15:30:00",
    statutAlerte: { libelleStatutAlerte: "Terminée" },
  },
  {
    id: "10",
    description: "Drainage bouché causant des inondations",
    libelleAlerte: "Drainage bouché - Zone inondable",
    typeTravaux: { libelleTypeTravaux: "Maintenance drainage" },
    priorite: { libellePriorite: "Urgente", id: "1" },
    commune: { libelleCommune: "Rufisque" },
    dateCreation: "2026-02-15T07:45:00",
    statutAlerte: { libelleStatutAlerte: "En cours" },
  },
];

export const fakeDegradations = [
  {
    id: "1",
    degradation: { libelleDegradation: "Nid de poule" },
    libelleDegradation: "Nid de poule",
  },
  {
    id: "2",
    degradation: { libelleDegradation: "Fissure longitudinale" },
    libelleDegradation: "Fissure longitudinale",
  },
  {
    id: "3",
    degradation: { libelleDegradation: "Fissure transversale" },
    libelleDegradation: "Fissure transversale",
  },
  {
    id: "4",
    degradation: { libelleDegradation: "Affaissement" },
    libelleDegradation: "Affaissement",
  },
  {
    id: "5",
    degradation: { libelleDegradation: "Ornière" },
    libelleDegradation: "Ornière",
  },
];

export const fakeGravites = [
  {
    id: "1",
    libelleNiveauGravite: "Critique",
    libelle: "Critique",
    notation: 5,
  },
  {
    id: "2",
    libelleNiveauGravite: "Élevée",
    libelle: "Élevée",
    notation: 4,
  },
  {
    id: "3",
    libelleNiveauGravite: "Moyenne",
    libelle: "Moyenne",
    notation: 3,
  },
  {
    id: "4",
    libelleNiveauGravite: "Faible",
    libelle: "Faible",
    notation: 2,
  },
  {
    id: "5",
    libelleNiveauGravite: "Minimale",
    libelle: "Minimale",
    notation: 1,
  },
];

export const fakeTypeDegradations = [
  { id: "1", libelleTypeDegradation: "Dégradation de surface", libelle: "Dégradation de surface" },
  { id: "2", libelleTypeDegradation: "Dégradation structurelle", libelle: "Dégradation structurelle" },
  { id: "3", libelleTypeDegradation: "Dégradation de sécurité", libelle: "Dégradation de sécurité" },
];

export const fakeEnsDegradations = [
  { id: "1", libelleEnsDegradation: "Famille fissures", libelle: "Famille fissures" },
  { id: "2", libelleEnsDegradation: "Famille déformations", libelle: "Famille déformations" },
  { id: "3", libelleEnsDegradation: "Famille détériorations", libelle: "Famille détériorations" },
];

export const fakeDegradationsList = [
  { id: "1", libelleDegradation: "Nid de poule", libelle: "Nid de poule" },
  { id: "2", libelleDegradation: "Fissure", libelle: "Fissure" },
  { id: "3", libelleDegradation: "Ornière", libelle: "Ornière" },
  { id: "4", libelleDegradation: "Affaissement", libelle: "Affaissement" },
];

export const fakeParametres = [
  { id: "1", libelleParametre: "Temps de réponse moyen", libelle: "Temps de réponse moyen", valeur: "24 heures" },
  { id: "2", libelleParametre: "Priorité par défaut", libelle: "Priorité par défaut", valeur: "Moyenne" },
  { id: "3", libelleParametre: "Superficie maximale", libelle: "Superficie maximale", valeur: "1000 m²" },
];

export const fakeTypeChausse = [
  { id: "1", libelleTypeChausse: "Béton", libelle: "Béton" },
  { id: "2", libelleTypeChausse: "Bitume", libelle: "Bitume" },
  { id: "3", libelleTypeChausse: "Gravier", libelle: "Gravier" },
];

export const fakeTypeAlerte = [
  { id: "1", idTypeAlerte: 1, libTypeAlerte: "Routière", libelle: "Routière" },
  { id: "2", idTypeAlerte: 2, libTypeAlerte: "Grand public", libelle: "Grand public" },
];

export const fakeRegions = [
  { id: "1", libelleRegion: "Dakar", libelle: "Dakar" },
  { id: "2", libelleRegion: "Thiès", libelle: "Thiès" },
  { id: "3", libelleRegion: "Saint-Louis", libelle: "Saint-Louis" },
];

export const fakeDepartements = [
  { id: "1", libelleDepartement: "Dakar", libelle: "Dakar", region: { libelleRegion: "Dakar" }, libelleRegion: "Dakar" },
  { id: "2", libelleDepartement: "Pikine", libelle: "Pikine", region: { libelleRegion: "Dakar" }, libelleRegion: "Dakar" },
  { id: "3", libelleDepartement: "Rufisque", libelle: "Rufisque", region: { libelleRegion: "Dakar" }, libelleRegion: "Dakar" },
  { id: "4", libelleDepartement: "Thiès", libelle: "Thiès", region: { libelleRegion: "Thiès" }, libelleRegion: "Thiès" },
];
